module.exports = __webpack_public_path__ + "static/media/Chris Mottla.162362e5.jpg";